export const collectionTitlesTagCollectionId =
  "c43fc973-6267-4169-ab4b-6786b8e79e2f";
export const processTagCollectionId = "71b8ba5f-288b-475f-80e0-117259190bb8";
export const variantsTagCollectionId = "e1de4982-8703-4795-a16b-a660797e9a9d";
